module.exports = __webpack_public_path__ + "img/eng_small_icon.a32edf1c.png";